module.exports = __webpack_public_path__ + "uarm-images/tinymce-k21.gif";